import Canvas from "./components/Canvas";
import Loading from "./components/Loading";

function App() {
  return (
  <div>
    <Canvas/>
    <Loading/>
  </div>);
}

export default App;
